import {
    Box,
    Grid,
    FormGroup,
    FormControlLabel,
    Checkbox
} from '@mui/material';
import { ContainedSearchButton } from '../../../components/Buttons';

export default function Ifx() {

    return (
        <Box>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="External account created" />
                    </FormGroup>
                </Grid>

            </Grid>
            <br></br>
            <ContainedSearchButton variant="contained" disabled>
                Create Account
            </ContainedSearchButton>
        </Box>
    );
}
